import { Component, OnInit } from '@angular/core';
import { DragAndDropBaseComponent } from '../drag-and-drop-base-component/drag-and-drop-base.component';
import { ChannelService } from './../../../../shared/services/channel/channel.service';
import { TranslatorService } from './../../../../shared/services/utils/translator.service';

@Component({
  selector: 'ngx-channel-drag-and-drop',
  templateUrl: './../drag-and-drop-base-component/drag-and-drop-base.component.html',
  styleUrls: ['./../drag-and-drop-base-component/drag-and-drop-base.component.scss']
})
export class ChannelDragAndDropComponent extends DragAndDropBaseComponent implements OnInit {

  constructor(private readonly channelService: ChannelService, translatorService: TranslatorService) {
    super(translatorService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.channelService.channelQuery$(null, null, false).subscribe(res => {
      this.itemsList = this.itemsList.concat(res.channelList);
    });

  }

}
